import { GungUser as User } from 'gung-standard';
import { inject, Injectable } from '@angular/core';
import { ConfigBaseFilter, ListLayout, ListLayoutMultipleComponent, SimpleConfigBaseFilter } from 'gung-list';
import { gungComparatorHelper, MetadataService, UsersListConfigService } from 'gung-standard';
import { map, Observable } from 'rxjs';
import { CarLinerUserTableComponent } from '../components/car-liner-user-table/car-liner-user-table.component';

@Injectable({
  providedIn: 'root'
})
export class CarLinerUsersListConfigService extends UsersListConfigService {
  protected metadataService = inject(MetadataService);

  getLayouts(): ListLayout<User>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => CarLinerUserTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'UserTable'
      }
    ];
  }

  getItems(): Observable<User[]> {
    return super.getItems().pipe(
      map(users =>
        users.sort((a, b) =>
          gungComparatorHelper(
            new Date(a?.extra?.createdAt).getTime() || 0,
            new Date(b?.extra?.createdAt).getTime() || 0,
            -1
          )
        )
      )
    );
  }

  getFilters(): ConfigBaseFilter<User>[] {
    return [...super.getFilters(), new UserCountryFilter(this.metadataService)];
  }
}

export class UserCountryFilter extends SimpleConfigBaseFilter<User> {
  constructor(private metadataService: MetadataService) {
    super();
  }

  getName(): string {
    return 'COUNTRY';
  }

  getOptionIds(item: User): string[] {
    return item.extra?.country ? [item.extra.country] : [];
  }

  getOptionName(key: string): string {
    return this.metadataService.getMetadataValue('xr', 'land', key) || key;
  }
}
